<template>
    <el-dialog title="抵扣记录" :visible.sync="dialog" width="1300px" :close-on-click-modal="false" >
      <BaseTable :tableData="tableData" :columns="payColumns" v-loading="loading">
        <template #offsetAmount="{ row }">
          <span v-if="row.deductionDirection === '出项'">
            -{{ row.offsetAmount}}
          </span>
          <span v-else>
            +{{ row.offsetAmount }}
          </span>
        </template>
      </BaseTable>
    </el-dialog>
</template>

<script>
import BaseTable from "@/components/BaseTable";
export default {
  name: "DeductionRecord",
  components: {
    BaseTable,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      total: 0,
      page: {
        size: 99999,
        current: 1
      },
      payColumns: [
                {
          prop: "deductionDirection",
          label: "抵扣方向(本单)",
        },
        {
          prop: "offsetAmount",
          label: "本单金额",
          slot: "offsetAmount",
        },
        {
          prop: "settlementBatchName",
          label: "抵扣方(对向单)-结算批次名称",
          showOverflowTooltip: true,
          width: 180,
        },
        // {
        //   prop: "userIdStr",
        //   label: "结算师傅名称",
        //   width: 135,
        // },
        {
          prop: "companyIdStr",
          label: "公司名称",
        },
        // {
        //   prop: "paymentTypeStr",
        //   label: "支付类型",
        // },
        // {
        //   prop: "allocatedAmount",
        //   label: "收到金额（本单）",
        //   width: 135,
        // },
        // {
        //   prop: "paymentAmount",
        //   label: "支付金额",
        // },
        // {
        //   prop: "paymentMethod",
        //   label: "付款方式",
        // },
        // {
        //   prop: "attachmentIds",
        //   label: "付款凭证",
        //   slot: "attachmentIds",
        // },
        {
          prop: "createdByStr",
          label: "操作人",
        },
        {
          prop: "createTime",
          label: "操作时间",
          width: 135,
        },
        // {
        //   prop: "statusStr",
        //   label: "状态",
        // },
        // {
        //   prop: "remarks",
        //   label: "备注",
        //   showOverflowTooltip: true,
        // },
      ],
      tableData: [],
    };
  },
  created() {
  },
  methods: {
    open(settlementOrderId){
      this.dialog = true
      this.loading = true
      this.tableData = []
      this.axios({
        url: '/v1/web/settlement-offset-relation/list?settlementOrderId=' + settlementOrderId,
        method: 'get',
      }).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    dialogClose() {
      this.dialog = false
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}

.container_table {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 5px 20px 20px;
}
</style>
